import SemanticStitchPage from './SemanticStitchPage'

export default SemanticStitchPage
